import { FILTERS_ACTIONS } from "../middleware/filtersMiddleware";

export const initializeFilters = () => ({
  type: FILTERS_ACTIONS.INITIALIZE_FILTERS,
});

export const fetchManagerWorkers = (startDate, endDate) => ({
  type: FILTERS_ACTIONS.FETCH_MANAGER_WORKERS,
  payload: { startDate, endDate },
});

export const updateDatesAndWorkers = (startDate, endDate) => ({
  type: FILTERS_ACTIONS.UPDATE_DATES_AND_WORKERS,
  payload: { startDate, endDate },
});

export const selectWorkers = (selectedWorkers) => ({
  type: FILTERS_ACTIONS.SELECT_WORKERS,
  payload: { selectedWorkers },
});

export const selectProjects = (selectedProjects, allProjects = false) => ({
  type: FILTERS_ACTIONS.SELECT_PROJECTS,
  payload: { selectedProjects, allProjects },
});

export const clearFilterState = () => ({
  type: FILTERS_ACTIONS.CLEAR_FILTER_STATE,
});
